import {useMemo, useReducer} from 'react';
import {useChangeParams} from 'hooks';
import {Button, DropdownSingle, TableCommon, Transitioner} from 'components';

import ModalTeamInvite from './Modal.Team.Invite';
import useTablePeople from '../hooks/useTablePeople';
import useTableInvites from '../hooks/useTableInvites';

interface ITeamMineProps {}

const TeamMine = ({}: ITeamMineProps) => {
  const [showModal, toggleModal] = useReducer(s => !s, false);

  const {searchParams, handleChangeParams} = useChangeParams();
  const filters = ['people', 'invites'];
  const filter = (filters.includes(searchParams.get('filter')!) ? searchParams.get('filter') : 'people') as 'people' | 'invites';
  const dropdownItems = useMemo(
    () => [
      {id: 'people', label: 'People', onClick: () => handleChangeParams({filter: 'people'})},
      {id: 'invites', label: 'Invitations', onClick: () => handleChangeParams({filter: 'invites'})},
    ],
    [handleChangeParams],
  );

  const tablePeople = useTablePeople({filter});
  const tableInvites = useTableInvites({filter});

  const filtersComp = useMemo(() => {
    return (
      <div className="flex justify-end">
        <DropdownSingle items={dropdownItems} selected={dropdownItems.find(i => i.id === filter)!} />
      </div>
    );
  }, [dropdownItems, filter]);

  return (
    <Transitioner>
      <div className="flex items-center justify-between">
        <div className="sm:flex-auto">
          <h1 className="font-medium text-lg dark:text-white">Team</h1>
          <p className="mt-2 text-sm text-gray-700 dark:text-darkText hidden sm:block">A list of all the collaborators of my projects.</p>
        </div>
        <Button text="+ Invite" size="small" onClick={toggleModal} />
      </div>
      <ModalTeamInvite visible={showModal} onClose={toggleModal} />
      <Transitioner delay={0.1}>
        {(() => {
          if (filter === 'people') return <TableCommon table={tablePeople} filters={filtersComp} />;
          if (filter === 'invites') return <TableCommon table={tableInvites} filters={filtersComp} />;
          return null;
        })()}
      </Transitioner>
    </Transitioner>
  );
};

export default TeamMine;
